module.exports = __webpack_public_path__ + "static/media/media.cb501f16.svg";